import React from 'react'
import './style.scss'
import { Icon } from 'react-icons-kit'
import Modal from 'react-bootstrap/Modal'
import { ic_clear } from 'react-icons-kit/md'

const Index = (props) => {
    return (
        <div>
            <Modal
                show={props.show}
                onHide={props.onHide}
                dialogClassName="custom-delete-modal"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <div className="d-flex justify-content-between w-100">
                        <div>
                            <h6 className="mb-0">Are you sure ?</h6>
                            <small className="text-muted"><i>Want to delete.</i></small>
                        </div>
                        <div className="ml-auto">
                            <button
                                type="button"
                                className="btn btn-sm btn-light shadow-none rounded-circle p-1"
                                onClick={props.onHide}
                                disabled={props.loading}
                            >
                                <Icon icon={ic_clear} size={25} />
                            </button>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <div className="text-center mb-4">
                        {props.image ? <img src={props.image} className="img-fluid" style={{ maxHeight: 200 }} alt="..." /> : null}
                    </div>
                    <div className='text-end'>
                        <button
                            type="button"
                            className="btn shadow-none yes-btn"
                            disabled={props.loading}
                            onClick={() => props.doDelete()}
                        >{props.loading ? 'Deleting....' : 'Yes'}</button>
                        <button
                            type="button"
                            className="btn shadow-none no-btn"
                            disabled={props.loading}
                            onClick={props.onHide}
                        >No</button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default Index;